import React, { Component } from 'react';
import styled from 'styled-components';
import Body from './Body';
const Container = styled.div`
display: flex;
flex-direction: column;
align-items: flex-start;
`
const Note = styled.p`
color:red;
`
export default class WelcomeVideo extends Component {
    render() {

        return (
            <Container>
                <Note>* Uploading a video will replace the existing one.</Note>
                <Body />
            </Container>
        )
    }
}